import State from 'store/State';
import { useWidgetContext } from 'widgets/WidgetContext';
import { useSelector } from 'react-redux';
import { selectPlCapsuleState } from 'widgets/plCapsule/store/selectors';

export const selectStreamState = (state: State, widgetKey: string) => {
    const capsuleState = selectPlCapsuleState(state, widgetKey);
    return capsuleState ? capsuleState.stream : undefined;
};

export const selectStreamKey = (state: State, widgetKey: string) => {
    const streamState = selectStreamState(state, widgetKey);
    return streamState ? streamState.streamKey : undefined;
};

export const useSelectPlCapsuleStreamState = () => {
    const { widgetKey } = useWidgetContext();
    return useSelector((state: State) => selectStreamState(state, widgetKey));
};
